<template>
  <div class="Dropdown" :class="{ 'is--open' : isOpen }">

    <button :class="'Dropdown__btn '+btnClass" @click="onToggle">
      <div class="inner">
        <slot name="btn"></slot>
      </div>
      <Icon name="dropdown-arrow"/>
    </button>

    <div :class="'Dropdown__body '+bodyClass" ref="DropdownBody">
      <div class="inner">
        <slot name="body"></slot>
      </div>
    </div>

  </div>
</template>

<script>
  import { gsap } from 'gsap'
  import Icon from '@components/Icon'
  import {Inertia} from "@inertiajs/inertia";

  export default {
    components: { Icon },
    props : [ "btnClass", "bodyClass" ],
    data() {
      return {
        isOpen : false
      }
    },
    methods: {
      onToggle() {
        this.isOpen = !this.isOpen

        if(!this.Open) window.removeEventListener('click', this.closeDropdown)

        const { DropdownBody } = this.$refs
        const innerHeight = DropdownBody.querySelector('.inner').offsetHeight

        gsap.to(DropdownBody, { height: this.isOpen ? innerHeight : 0, duration: 0.6, ease: 'expo.out', onComplete: () => {
          if( this.isOpen ) window.addEventListener('click', this.closeDropdown)
        }})
      },
      closeDropdown(event) {
        if (!event || (!event.target.matches('.Dropdown') && !this.$el.contains(event.target))) this.onToggle()
      }
    },
    unmounted() {
      if( this.isOpen ) window.removeEventListener('click', this.closeDropdown)
    }
  }

</script>

<style lang="scss">
  @import "~@sass/components/_Dropdown.scss";
</style>
